import { render, staticRenderFns } from "./SpecificItemPage.vue?vue&type=template&id=4ef4d1bf&scoped=true"
import script from "./SpecificItemPage.vue?vue&type=script&lang=js"
export * from "./SpecificItemPage.vue?vue&type=script&lang=js"
import style0 from "./SpecificItemPage.vue?vue&type=style&index=0&id=4ef4d1bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef4d1bf",
  null
  
)

export default component.exports